export default "/images/aeed4e692b524798ad54fde1425ab504.avif";